var map = {
	"./airbnb_logo.png": "8e39",
	"./facebook_logo.png": "6b44",
	"./google_logo.png": "ebbc",
	"./instagram_logo.png": "9f85",
	"./linkedin_logo.png": "70e1",
	"./tripadvisor_logo.png": "5d05",
	"./twitter_logo.png": "8381",
	"./yelp_logo.png": "0233",
	"./youtube_logo.png": "14c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f053";